// ホワイトペーパー公開設定
// このファイルを更新することで、公開するレポートを管理できます

// 現在公開中のホワイトペーパーID
export const AVAILABLE_WHITEPAPERS = ['wp01', 'wp02', 'wp03', 'wp04', 'wp05', 'wp06', 'wp07', 'wp08', 'wp09', 'wp10', 'wp11', 'wp12', 'wp13', 'wp14', 'wp15', 'wp17', 'wp18', 'wp27'];

// 準備中メッセージ
export const COMING_SOON_MESSAGE = '準備中';

// 新着バッジの表示設定
export const NEW_RELEASE_CONFIG = {
  enabled: true,  // 新着バッジを表示するか
  newIds: ['wp17', 'wp18', 'wp27'],  // 新着扱いのID
  message: 'NEW!'  // バッジに表示するテキスト
};

// 公開予定日（オプション：今後の機能拡張用）
export const RELEASE_SCHEDULE = {
  'wp04': '2025-10-01',
  'wp05': '2025-10-01',
  'wp06': '2025-10-01',
  'wp07': '2025-10-08',
  'wp08': '2025-10-08',
  'wp09': '2025-10-08',
  // 以降、段階的に追加
};

// ダウンロード可能かチェック
export const isAvailable = (whitepaperId) => {
  return AVAILABLE_WHITEPAPERS.includes(whitepaperId);
};

// 公開本数を取得
export const getAvailableCount = () => {
  return AVAILABLE_WHITEPAPERS.length;
};

// フォーム用のメッセージ
export const FORM_MESSAGES = {
  memberBenefit: `公開中の${AVAILABLE_WHITEPAPERS.length}本のレポート即時ダウンロード`,
  motivation: `🎯 あと少しで${AVAILABLE_WHITEPAPERS.length}本のレポートが手に入ります`,
  newRelease: '※ 新しいレポートを順次追加予定！'
};